var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"description"},[_c('p',[_vm._v(_vm._s(_vm.content))]),(_vm.source)?_c('p',{staticClass:"source"},[_vm._v(_vm._s(_vm.$t("component.description.source"))+": "+_vm._s(_vm.source))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }